<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="用户账号" prop="userName">
            <el-input v-model="queryForm.userName" placeholder="请输入用户账号"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="用户类型" prop="userType">
            <el-select v-model="queryForm.userType" clearable placeholder="请选择用户类型">
              <el-option
                  v-for="item in allUserType"
                  :key="item.userTypeNum"
                  :label="item.userTypeName"
                  :value="item.userTypeName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="状态" prop="status">
            <el-select v-model="queryForm.status" clearable placeholder="请选择状态">
              <el-option
                  v-for="item in statusOptions"
                  :key="item.flag"
                  :label="item.value"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="审核人" prop="reviewUserName">
            <el-input v-model="queryForm.reviewUserName" placeholder="请输入审核人"/>
          </el-form-item>
        </el-col>
        <!--<el-col :span="5">
          <el-form-item label="审核时间" prop="status">
            <el-select v-model="queryForm.status" clearable placeholder="请选择时间类型">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.flag"
                  :value="item.flag"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>-->
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="时间段" prop="timeRange">
            <el-date-picker
                v-model="queryForm.timeRange"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="4">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
            <el-button type="primary" size="small" plain
                       @click="exportCashOutMoneyData" icon="el-icon-refresh">
              导出</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card
      v-loading.fullscreen.lock="fullscreenLoading">
    <el-button type="success" size="small" style="margin: 0 0 10px 20px"
               @click="handleReviewBatch">批量通过</el-button>
    <el-button type="success" size="small" style="margin: 0 0 10px 20px"
               @click="handleReviewPrcBatch">批量审核中</el-button>
    <el-table :data="tableData"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              :max-height="tableHeight"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}"
              @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection" :selectable="isEnabledSelected"/>
      <el-table-column prop="applyDateTime" label="时间" />
      <el-table-column prop="transactionNumber" label="交易流水号" />
      <el-table-column prop="userName" label="用户账号" >
       <!-- <template slot-scope="scope">
          <span>{{getStrEndWithNumbers(scope.row.b2cUsersId)}}</span>
        </template>-->
      </el-table-column>
      <el-table-column prop="userType" label="用户类型" />
      <el-table-column prop="ownerWebAndPersonName" label="分站/业务员" />
      <el-table-column prop="userBackInfo" label="提现信息" width="180">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="24">
              <div  style="text-align: left" v-html="scope.row.userBackInfo"></div>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column prop="cashOutMoney" label="金额" />
      <el-table-column prop="updateTime" label="审核时间">
        <!--<template slot-scope="scope">
          <span v-if="scope.row.statusStr=='审核通过'">{{scope.row.updateTime}}</span>
        </template>-->
      </el-table-column>
      <el-table-column prop="statusStr" label="状态" />
      <el-table-column prop="operationPerson" label="操作人">
        <!--<template slot-scope="scope">
          <span v-if="scope.row.statusStr=='审核通过'">{{scope.row.operationPerson }}</span>
        </template>-->
      </el-table-column>
      <el-table-column prop="changeType" label="类型">
        <template slot-scope="scope">
          <span>{{scope.row.changeType?"增加":"减少"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注" />
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="success" v-show="scope.row.statusStr != '审核通过'"
                     @click="handleEdit(scope.$index, scope.row,'提现审核')">
            审核
          </el-button>
          <el-button size="mini" type="success"
                     @click="handleEdit(scope.$index, scope.row, '提现信息')">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>

  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
    <el-form ref="dialogForm" :model="dialogForm" label-width="260px">
      <el-form-item label="审核时间">
        <span>{{dialogForm.applyDateTime}}</span>
      </el-form-item>
      <el-form-item label="提现编号">
        <span>{{dialogForm.transactionNumber}}</span>
      </el-form-item>
      <el-form-item label="用户账号">
        <span>{{getStrEndWithNumbers(dialogForm.b2cUsersId)}}</span>
      </el-form-item>
      <el-form-item label="用户类型">
        <span>{{dialogForm.userType}}</span>
      </el-form-item>
      <div v-if="dialogForm.userType != '试客'">
        <el-form-item label="提现类型">
          <span>银行卡</span>
        </el-form-item>
        <el-form-item label="提现银行">
          <span>{{dialogForm.cashOutBack}}</span>
        </el-form-item>
        <el-form-item label="开户行">
          <span>{{dialogForm.cashOutOpenBack}}</span>
        </el-form-item>
        <el-form-item label="提现人姓名">
          <span>{{dialogForm.cashOutUserName}}</span>
        </el-form-item>
        <el-form-item label="提现人卡号/账号">
          <span>{{dialogForm.cashOutAccount}}</span>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="真实姓名">
          <span>{{dialogForm.customerName}}</span>
        </el-form-item>
        <el-form-item label="身份证号码">
          <span>{{dialogForm.customerCardId}}</span>
        </el-form-item>
        <el-form-item label="地址">
          <span>{{dialogForm.customerAddress}}</span>
        </el-form-item>
        <el-form-item label="身份证图片">
          <span>{{dialogForm.customerCardUrl}}</span>
        </el-form-item>
      </div>
      <el-form-item label="提现金额">
        <span style="color: red">{{dialogForm.cashOutMoney}}</span>
      </el-form-item>
      <el-form-item label="提现备注">
        <span style="color: red">{{dialogForm.remarks}}</span>
      </el-form-item>
      <el-form-item label="审核状态">
        <span style="color: red">{{dialogForm.statusStr}}</span>
      </el-form-item>
      <div v-show="dialogTitle == '提现审核'">
        <el-form-item label="审核操作">
          <el-select v-model="dialogForm.statusStr" clearable style="width: 30%" size="mini">
            <el-option
                v-for="item in statusOptions"
                :key="item.flag"
                :label="item.value"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核原因">
          <el-input v-model="dialogForm.remarks" style="width: 50%;" size="mini"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitReviewDialogForm()" size="mini" type="primary" v-show="dialogTitle == '提现审核'">审核</el-button>
      <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {
  changeCashOutMoneyProcStatusBatch,
  changeCashOutMoneyStatus,
  changeCashOutMoneyStatusBatch, getAllUserType,
  queryCashOutInfo
} from "../../api/b2cbusiness/b2c_admin";
import {getStrEndWithNumbers} from "../../lib/utils";
import {updateShopStatus} from "../../api/b2cbusiness/storelist";
import qs from "qs";
import MinxinScroll from "@/components/MinxinScroll";
export default {
  name: "AccountOutChangeManeylist",
  mixins:[MixinCUD, MinxinScroll],
  data(){
    return {
      fullscreenLoading: false,
      tableData:[],
      allUserType:[],
      queryFormRefName:"queryForm",
      queryForm:{
        userName: '',
        userType: '',
        status: null,
        reviewUserName: '',
        timeRange:[],
      },
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm:{
      },
      statusOptions: [
        {
          flag:"202111300003" ,
          value:"审核通过",
        },
        {
          value:"审核中",
          flag: '202206060001'
        },
        {
          flag: "202111300002" ,
          value:"审核未通过",
        },
        {
          flag: "202111300001" ,
          value:"未审核",
        }
      ],
      tableHeight: 850,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    //this.tableHeight = document.body.clientHeight - 220;
    getAllUserType().then(res=>{
      if (res.success){
        console.log(res.data)
        this.allUserType = res.data;
      }
    });
    if (this.$route.query.userType != null && this.$route.query.status){
      this.queryForm.userType = this.$route.query.userType;
      this.queryForm.status = this.$route.query.status;
    }
    this.getData();
  },
  methods: {
    isEnabledSelected(row, index){
      if (row.statusStr == "审核通过"){
        return false;
      }else{
        return true;
      }
    },
    exportCashOutMoneyData(){
      window.open("https://api.weiquanai.com/b2ccashoutmoney/exportdata?"+qs.stringify({
        userName: this.queryForm.userName,
        userType: this.queryForm.userType,
        status: this.queryForm.status,
        reviewUserName: this.queryForm.reviewUserName,
        startTime: this.queryForm.timeRange?this.queryForm.timeRange[0]:null,
        endTime: this.queryForm.timeRange?this.queryForm.timeRange[1]:null,
        pageNum: -1,
        pageSize: -1,
      }), "_blank");
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
      console.log(this.multipleSelection)
    },
    getData(){
      this.fullscreenLoading = true
      queryCashOutInfo(this.queryForm, this.pagination).then(res=>{
        if (res.success) {
          console.log(res.data.records);
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
        this.fullscreenLoading = false
      }).catch(err => {
        this.fullscreenLoading = false
        this.$message({message: err.message, type: 'error'});
      });
    },
    submitReviewDialogForm(){
      this.$refs[this.dialogRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                this.fullscreenLoading = true
                changeCashOutMoneyStatus({transactionNumber: this.dialogForm.transactionNumber, id:this.dialogForm.id, status:this.dialogForm.statusStr, remarks:this.dialogForm.remarks}).then(res=>{
                  if (res.success){
                    this.fullscreenLoading = false
                    this.getData();
                    this.$message.success("更新状态成功！")
                    this.dialogFormVisible = false;
                  }
                }).catch(err => {
                  this.fullscreenLoading = false
                  this.$message({message: err.message, type: 'error'});
                });
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        } else {
          return false;
        }
      });
    },
    handleReviewBatch(){
      if (this.multipleSelection.length > 0){
        this.$confirm("确定提交数据么?")
            .then(_ => {
              this.fullscreenLoading = true
              changeCashOutMoneyStatusBatch({b2cCashOutMoneyManages:this.multipleSelection}).then(res=>{
                if (res.success){
                  this.fullscreenLoading = false
                  this.getData();
                  this.$message.success("更新状态成功！")
                }
              }).catch(err => {
                this.fullscreenLoading = false
                this.$message({message: err.message, type: 'error'});
              });
              //取消新增或修改也要重置表单
            }).catch(err => {this.handleCloseDialog();});
      }else{
        this.$message.warning("请选择要批量审核的数据！")
      }
    },
    handleReviewPrcBatch(){
      if (this.multipleSelection.length > 0){
        this.$confirm("确定提交数据么?")
            .then(_ => {
              this.fullscreenLoading = true
              changeCashOutMoneyProcStatusBatch({b2cCashOutMoneyManages:this.multipleSelection}).then(res=>{
                if (res.success){
                  this.fullscreenLoading = false
                  this.getData();
                  this.$message.success("更新状态成功！")
                }
              }).catch(err => {
                this.fullscreenLoading = false
                this.$message({message: err.message, type: 'error'});
              });
              //取消新增或修改也要重置表单
            }).catch(err => {this.handleCloseDialog();});
      }else{
        this.$message.warning("请选择要批量审核的数据！")
      }
    },
    getStrEndWithNumbers(numbers) {
      if (numbers != null){
        return getStrEndWithNumbers(numbers, 8);
      }
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.el-form-item{
  margin-bottom: 10px;
}

/deep/ .el-dialog__body{
  padding: 0;
}

/deep/ .el-dialog .el-form .el-form-item__label{
  line-height: 21px !important;
}

/deep/ .el-dialog .el-form .el-form-item__content{
  line-height: 21px !important;
}
</style>
